const websiteText={
  menu:[
    {name:"首页",class:'right',pclass:'bold',tolink:'/' },
    {name:"CRM",class:'right',pclass:'bold',tolink:'/crm'},
    {name:"外呼系统",class:'right',pclass:'bold',tolink:'/outbound'},
    {name:"产品",class:'down icon-jiahao',pclass:'bold',second:'true',children:[
      {name:'营销服务',class:'icon-jiahao',second:'true',children:[
        // {name:"小蜂助手",class:'right',tolink:'/product/robot',src:require('../assets/img/menu-icon1.png')},
        {name:"慧云名片",class:'right',tolink:'/product/card',src:require('../assets/img/menu-icon2.png')},
        {name:"慧获客",class:'right',tolink:'/product/huiVisitors',src:require('../assets/img/menu-icon3.png')},
        {name:"微客服",class:'right',tolink:'/product/customer',src:require('../assets/img/menu-icon4.png')},
        {name:"表单营销",class:'right',tolink:'/product/formMarket',src:require('../assets/img/menu-icon5.png')},
        {name:"微销",class:'right',tolink:'/product/wxMarket',src:require('../assets/img/menu-icon6.png')},
        // {name:"海报裂变",class:'right',tolink:'/product/poster',src:require('../assets/img/menu-icon7.png')},
        // {name:"热点推广",class:'right',tolink:'/product/hot',src:require('../assets/img/menu-icon8.png')},
        // {name:"场景秀",class:'right',tolink:'/product/show',src:require('../assets/img/menu-icon9.png')},
        // {name:"融E信",class:'right',tolink:'/product/letterE',src:require('../assets/img/menu-icon10.png')},
        {name:"电销卡",class:'right',tolink:'/product/sale',src:require('../assets/img/menu-icon11.png')},
        {name:"电销线路",class:'right',tolink:'/telemarketingLine',src:require('../assets/img/menu-icon11.png')},
      ]},
        {name:'智能硬件',class:'icon-jiahao',second:'true',children:[
        {name:"快话UH4",class:'right',tolink:'/product/huiTalk',src:require('../assets/img/menu-icon11.png')},
        {name:"IP交换机",class:'right',tolink:'/product/ipswitch',src:require('../assets/img/menu-icon12.png')},
      ]},
    ]},
    {name:"找企鸟",class:'right',pclass:'bold',tolink:'/zqn'},
    {name:"关于我们",class:'right',pclass:'bold',tolink:'/about'},
    {name:"新闻动态",class:'right',pclass:'bold',tolink:'/news'},
    {name:"招商代理",class:'right',pclass:'bold',tolink:'/BusAgent'},
  ],
  home:{
      modular1:{
        title:'凝聚核心价值',
        p:'慧营销始终以为"中小企业提供高价值低成本的营销服务"为己任，不断在企业营销服务的道路上开拓创新，形成了企业营销推广、获客、开发、管理、运营、维护的全流程企业营销服务体系，从而更好的赋能企业创造价值',
        img:{
          imgsrc:require('../assets/img/home-img1.png'),
          imgtitle:'',
          imgalt:'',
          class:''
        },
        bp:''
      },
      modular2:{
        title:'多渠道获客引流',
        p:'大数据获客平台找企鸟，主流平台的线索开发及转化使用慧获客，企蜂名片打造私域流量建设，企业微信专属活码获客分流',
        img:null,
        class:'modular2',
        ullist:[
          {
            title:'找企鸟',
            p:'大数据获客找商机<br /> 筛选高意向客户',
            src:require('../assets/img/home-img2.png'),
          },{
            title:'慧获客',
            p:'一键入库，轻松获客<br /> 智能分析，拒绝撞单',
            src:require('../assets/img/home-img3.png'),
          },{
            title:'企蜂名片',
            p:'解锁企业私域流量<br /> 高效品牌推广引流',
            src:require('../assets/img/home-img4.png'),
          },{
            title:'企业微信',
            p:'一个渠道对应一个活码<br />自动打标签，自动分配',
            src:require('../assets/img/home-img5.png'),
          }
        ],
        bp:''
      },
      modular3:{
        title:'高效的营销管理',
        p:'',
        img:{
          imgsrc:require('../assets/img/home-img6.png'),
          imgtitle:'',
          imgalt:'',
          class:''
        },
        class:'modular3',
        ullist:[
          {
            title:'营销计划贯穿全程',
            p:'业绩目标自下而上自动量化、逐层分解精细化管理销售计划，细化销售任务',
          },{
            title:'营销过程动态跟进',
            p:'透明管理效率提升，执行进度实时跟踪',
          },{
            title:'营销数据支撑决策',
            p:'执行数据自动上报汇总，依托数据调整业绩目标多维度数据体现销售过程及销售业绩，帮助开展日程管理工作',
          },{
            title:'团队文化激发销售热情',
            p:'打赏、徽章、弹幕、积分、荣誉墙',
          }
        ],
        bp:''
      },
      modular4:{
        title:'促进营销效率翻倍',
        p:'',
        class:'modular4',
        img:{
          imgsrc:require('../assets/img/home-img7.png'),
          imgtitle:'',
          imgalt:'',
          class:''
        },
        ullist:[
          {
            p:'记忆导入<br />智能匹配',
          },{
            p:'多模式多策略<br />意向开发工具'
          },{
            p:'屏幕取号<br />自动对比',
          },{
            p:'网站客户<br />自动发现',
          },{
            p:'整合电话/短信<br />邮件/QQ/微信/旺旺',
          },{
            p:'秒级筛客<br />一键拨号',
          }
        ],
        bp:''
      },
      modular5:{
        title:'企业通信畅达无忧',
        p:'',
        img:{
          imgsrc:require('../assets/img/home-img8.png'),
          imgtitle:'',
          imgalt:'',
          class:''
        },
        bp:'为企业提供基于固话、手机的软硬一体化的通信解决方案<br />支持移动、联通、电信三大运营商<br />支持4G全网通，双卡智能切换<br /> 提供开放的API接口，快捷方便接入第三方软件'
      },
      modular6:{
        title:'提升服务满意度',
        p:'慧营销的价值是为中小企业提供优质的营销服务，您的满意是我们看重的、关心的。为了赢得您对慧营销的认可，慧营销从多方面优化售后流程，提升服务人员的技能水平和服务水准',
        img:{
          imgsrc:require('../assets/img/home-img9.png'),
          imgtitle:'',
          imgalt:''
        },
        bp:''
      },
      modular7:{
        title:'100000+企业',
        p:'覆盖互联网金融、电商、汽车、在线教育、企业服务、医疗等众多领域',
        img:{
          imgsrc:require('../assets/img/home-img10.png'),
          imgtitle:'',
          imgalt:''
        }
      },
  },
  CRM:{
    modular1:{
      title:'销售效率高效提升',
      p:'在大数据、云计算背景下，中小企业的营销方式悄然转型，慧营销整合多种客户开发工具，真正解决企业营销效率问题',
      img:{
        imgsrc:require('../assets/img/crm-img1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular2:{
      title:'客户资源轻松盘活',
      p:'客户是企业核心资产，如何管理、盘活客户资产无疑是企业生存之根本，慧营销统筹全生命周期的客户管理模型，打通挖掘、跟进、签约、维护全流程，实现客户资产轻松盘活',
      img:null,
      class:'crmModular1',
      ullist:[
        {
          p:'客户导入维护评估',
          src:require('../assets/img/crm-img2.png'),
        },{
          p:'生命周期客户管理',
          src:require('../assets/img/crm-img3.png'),
        },{
          p:'客户变化实时追溯',
          src:require('../assets/img/crm-img4.png'),
        },{
          p:'方便易用资源分配',
          src:require('../assets/img/crm-img5.png'),
        },{
          p:'库容管理加速流转',
          src:require('../assets/img/crm-img6.png'),
        },{
          p:'时时管理存量客户',
          src:require('../assets/img/crm-img7.png'),
        }
      ],
    },
    modular3:{
      title:'PDCA式计划任务',
      p:'正确的根据往年业绩、公司现有资源配置和市场发展趋势对全年的目标进行分解、执行、跟踪、督导和优化是保障全年目标实现的关键。慧营销业绩目标与销售计划匹执行，精准实现目标落地，随时随地穿透销售进度',
      img:{
        imgsrc:require('../assets/img/crm-img8.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular4:{
      title:'销售团队透明管理',
      p:'针对团队狼性差、成员年轻化、绩效考核难等问题，慧营销通过透明的数据化管理模式，打造高效营销团队',
      img:null,
      class:'crmModular1 crmModular2',
      ullist:[
        {
          p:'知识库促进成长',
          src:require('../assets/img/crm-img9.png'),
        },{
          p:'透明化绩效考核',
          src:require('../assets/img/crm-img10.png'),
        },{
          p:'随时听取录音',
          src:require('../assets/img/crm-img11.png'),
        },{
          p:'线上及时点评指导',
          src:require('../assets/img/crm-img12.png'),
        }
      ],
    },
    modular5:{
      title:'销售文化快乐至上',
      p:'要形成一支能够持续打胜仗的销售团队，不能忽视销售文化对企业的影响力。慧营销以快乐为核心打造销售文化',
      img:{
        imgsrc:require('../assets/img/crm-img13.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular6:{
      title:'慧营销APP',
      p:'要形成一支能够持续打胜仗的销售团队，不能忽视销售文化对企业的影响力，慧营销以快乐为核心打造销售文化',
      img:{
        imgsrc:require('../assets/img/crm-img14.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
  },
  Outbound:{
    modular2:{
      title:'产品优势',
      p:'',
      img:{
        imgsrc:require('../assets/img/Outbound-img2.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular3:{
      title:'适用场景',
      p:'',
      img:{
        imgsrc:require('../assets/img/Outbound-img3.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular4:{
      title:'销售服务',
      ullist:[
        {
          title:'传统营销方式效率低',
          p:'中小企业传统的上门推广、发传单的销售模式，受到地域性、人力的限制，很难在短期内快速的挖掘意向客户'
        },
        {
          title:'快速筛选客户线索',
          p:'慧营销外呼系统，为中小企业提供高效的电话营销服务，告别低效的销售方式，用户通过外呼系统，可以方便的拨打电话、使用话术，快速的筛选客户线索，挖掘有价值的意向客户，跟进客户并创造高价值客户'
        },
        {
          title:'高效管理销售工作',
          p:'管理者也通过外呼系统，方便的管理每一个销售的工作，从而不断优化、提升销售的工作'
        }
      ],
    },
    modular5:{
      title:'售后服务',
      ullist:[
        {
          title:'自动关怀、提升满意度',
          p:'定期发送关怀短信，电话回访客户，方便客服了解客户的需求'
        },
        {
          title:'提升服务的效率和口碑',
          p:'标准化的售后服务流程，降低了企业对员工的培训成本，提升了员工维护客户的质量，统一的客户回访话术，提升了客户对企业服务的满意度和服务口碑'
        },
        {
          title:'提升管理的质量和成果',
          p:'实时了解运营客服人员的工作安排和工作内容，通过不断的跟进工作，指导工作进而优化运营服务人员的工作效率，提高运营客服人员的工作质量和成果转化'
        }
      ],
    },
    modular6:{
      title:'产品主要功能',
      p:'',
      img:{
        imgsrc:require('../assets/img/Outbound-img5.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    }
  },
  BusAgent:{
    modular1:{
      title:'为什么选择企蜂？',
      p:'当信息化已经成为大中型企业的核心竞争力的时候，中小微企业的信息化却才刚刚起步。在全国4200多万户中小企业中，仅有30%能够利用信息技术开展生产管理和市场营销活动，另外有60%仅能够利用互联网获取市场信息。营销是解决中小企业销售困境的重要手段，提升企业营销力迫在眉睫，这是一个万亿级的企业互联网市场。以“云应用+云通信+智能硬件”的一站式SaaS模式数据化精准营销将独具特色，以人为本的营销设计思想将帮助企业在“互联网+大背景下突破营销”，实现转型，赢得未来！',
      img:{
        imgsrc:require('../assets/img/busagent-img1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      } 
    },
    modular2:{
      title:'我们为渠道提供什么？',
      p:'',
      class:'agentModular2',
      ullist:[
        {
          title:'培训支持',
          p:'产品培训：教练式的产品售前、使用培训<br />业务扶持：提供销售模式、销售话术、解决方案、销售实战等业务扶持<br />专项培训：定期举办产品售前、售后渠道',
          src:require('../assets/img/whatwegive_parttoppic1_hover.png')
        },
        {
          title:'市场支持',
          p:'网络推广：针对全国市场提供搜索推广网络广告视频推广以及自媒体推广<br />线下推广：提供会展、圈子、产品发布 会等线下推广活动',
          src:require('../assets/img/whatwegive_parttoppic2_hover.png')
        },
        {
          title:'售后支持',
          p:'7*12小时顾问式客服一对一服务<br />提供技术支持、远程协作、问题处理等服务<br /> 提供安装、使用、维护标准化作业指导规范',
          src:require('../assets/img/whatwegive_parttoppic3_hover.png')
        },
        {
          title:'运营支持',
          p:'协助代理商完成运营销模式、阶段性营销计划、销售目标执行等方面的管理支持提供销售、市场、运营等规范运行支持',
          src:require('../assets/img/whatwegive_parttoppic4_hover.png')
        },{
          title:'物料支持',
          p:'包括但不限于产品单页、产品手册、营销宝典、会议物料、产品视频、H5页面等',
          src:require('../assets/img/whatwegive_parttoppic5_hover.png')
        },{
          title:'奖励支持',
          p:'销售返点、促销奖励、代理商PK定期评选优秀代理商，给予现金奖励及产品赠送',
          src:require('../assets/img/whatwegive_parttoppic6_hover.png')
        }
      ]
    },
    modular3:{
      title:'加盟资历',
      p:'企蜂通信为渠道授权代商量身打造一整套的成长帮扶计划。通过多样化的市场、销售、服务、培训及技术支持，帮助授权代理商快速成长，成为企蜂授权区域销售和服务中心，满足当地日益增长的市场需求，并以开放、融合、共创的合作理念，与各授权代理商共享市场资源，共同为终端用户提升企业营销力，实现三方共赢！',
      class:'agentModular3',
      ullist:[
        {p:"独立承担民事责任的企业"},
        {p:"在当地有良好的客户资源"},
        {p:"熟悉企业市场、电信和相关领域产品"},
        {p:"有本地化的服务和支撑能力"},
        {p:"有较强市场拓展能力"}
      ]
    },
  },
  About:{
    modular1:{
      title:'我们是谁',
      p:'',
      img:{
        imgsrc:require('../assets/img/about-img1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:'浙江企蜂信息技术有限公司位于美丽的西子湖畔，从2014年成立以来，秉承“赋能中小企业，帮助企业提升竞争力！”的企业使命，致力于整合云通信和大数据技术，运用自主研发的智能硬件，为中小企业提供一站式智能综合营销服务平台，帮助企业引流优质客户，提高效率，提升管理，优化运维。'
    },
    modular2:{
      text:'天行健，君子以自强不息。企蜂与广大中小微企业一样，在以云计算、大数据、“互联网+”的时代背景下开拓和发展企业。这是一个新的机遇，同时也是新的挑战，企业如何转变、转型以适应新的发展成为新的重大问题。过去或许失之于PC互联网时代，但是现在有机会崛起于新的浪潮，决胜于今天的“互联网+”。今天的企业经营目的不是让风险变小，而是需要自由和速度变大。而恰恰“互联网+”和互联网化的转型，需要自由和速度。 企蜂通信的责任和使命就是帮助企业经营更加自由、灵活、敏捷、高效，帮助企业在“互联网+”时代下成功实现组织高效、业绩倍增和超越客户满意度。 企蜂人深知自己的路才刚刚开始，相信有您的陪伴，我们并不孤独。感谢一路有您陪伴，让我们一道在这个新时代取得丰硕的成绩。'
    },
    modular3:{
      title:'我们的文化',
      p:'',
      img:{
        imgsrc:require('../assets/img/about-img3.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular4:{
      title:'联系我们',
      class:'aboutModu',
      ullist:[
        {
          title:'浙江企蜂信息技术有限公司',
          p:'联系人：姚先生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18958188698<br /> 地址： 浙江省杭州市西湖区翠苑街道古翠路80号浙江科技产业大厦12楼'
        },
        // {
        //   title:'杭州分公司',
        //   p:'联系人：姚先生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18958188698<br />地址：浙江省杭州市西湖区古翠路80号浙江科技产业大厦12楼'
        // },{
        //   title:'上海分公司',
        //   p:'联系人：陈先生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18918158129<br />地址：上海市虹口区天宝路578号飘鹰世纪大厦1307'
        // },{
        //   title:'湖南分公司',
        //   p:'联系人：王先生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18975197818<br /> 地址：长沙市建湘路32号天心城市广场北栋2806'
        // }
      ]
    }
  },
  Ipswitch:{
    modular1:{
      title:'电信级设备',
      p:'源于大型交换系统支持平行扩容',
      img:{
        imgsrc:require('../assets/img/ipswitch-img1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:''
    },
    modular2:{
      title:'可靠交换协议',
      p:'支持可编程受控交换或自动交换<br />支持SIP网络通信协议<br />同一设备内支持ANS标准<br />',
      img:{
        imgsrc:require('../assets/img/ipswitch-img3.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:''
    },
  },
  FormMarket:{
    modular1:{
      title:'获客如此简单',
      p:'',
      img:{
        imgsrc:require('../assets/img/formMarket-img1.png'),
      },
    },
    modular2:{
      title:'极简表单 . 更易传播',
      p:'',
      img:{
        imgsrc:require('../assets/img/formMarket-img2.png'),
      },
    },
    modular3:{
      title:'使用场景',
      p:'表单主要是面向以C端业务为主的企业，业务的本地化、区域性属性较强，尤其适合以线下门店为主的教育培训类、健身类、美容等行业',
      img:{
        imgsrc:require('../assets/img/formMarket-img3.png'),
      },
    },
  },
  HuiTalk:{
    modular1:{
      title:'即插即用',
      p:'傻瓜式的组装<br /> 无需说明即能独立完成无需安装任何驱动、系统',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/huiTalk-img1.png'),
      },
    },
    modular2:{
      title:'通话录音',
      p:'实现自动录音，播放通话录音<br />通话声音清晰、信号稳定<br />抗干扰能力强',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/huiTalk-img2.png'),
      },
    },
    modular3:{
      title:' 通信网络',
      p:'支持CDMA、GSM网络制式<br />支持移动、联通、电信三大运营商<br />支持连接SIP话机',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/huiTalk-img3.png'),
      },
    },
    modular4:{
      title:' 接口能力',
      p:'开放的API接口<br />H型慧营销专用版支持慧营销系统<br />S型通用版对接第三方系统',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/huiTalk-img4.png'),
      },
    },
  },
  HuiVisitors:{
    modular1:{
      title:'多渠道轻松获客',
      p:'',
      img:{
        imgsrc:require('../assets/img/huiVisitors-img1.png'),
      },
    },
    modular2:{
      title:'快速获客',
      p:'慧获客一种直接的获客方式，用户在渠道内（企查查、天眼查、启信宝、阿里巴巴、搜客宝）查看客户信息的同时，慧获客能直接获取信息，一次点击即可查看入库；提高搜索效率，帮助企业获取客户信息',
      img:{
        imgsrc:require('../assets/img/huiVisitors-img2.png'),
      },
    },
    modular3:{
      title:'更多渠道',
      p:'电商用户可以使用慧获客在阿里巴巴网站上获取网店资料，泛行业用户能够在企查查、天眼查、启信宝、搜客宝上直接搜客撞单快速入库',
      img:{
        imgsrc:require('../assets/img/huiVisitors-img3.png'),
      },
    },
  },
  Card:{
    modular1:{
      title:'聚集人脉秒变营销宠儿',
      p:'沟通从未如此有趣',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/card-img1.png'),
      },
      bp:''
    },
    modular2:{
      title:'电子名片 • 一秒传播',
      p:'',
      class:'card',
      img:null,
      ullist:[
        {
          title:'制作简便 • 立体多维',
          p:'模板化的个性名片，风格各异多样化，适用于不同行业和用途；呈现企业的产品信息、公司信息、销售人员信息，并可以根据用户实际情况调整个人、产品以及公司信息的布局和内容',
          src:require('../assets/img/card-img2.png'),
        },
        {
          title:'推广引流 • 提升品牌',
          p:'基于微信10亿的用户流量，借助一定的推广策略实现快速的传播，高效的寻找目标客户，实时了解客户的关注点，精确获取客户的浏览轨迹，获取高意向客户；以名片统一的风格、统一的企业介绍、产品介绍，更好地推广企业的品牌文化，提升品牌价值',
          src:require('../assets/img/card-img3.png'),
        },
        {
          title:'客户跟进 • 科学管理',
          p:'通过微信渠道传播，快速发现目标客户；访客咨询、浏览信息会及时通知销售，销售第一时间了解相关提醒，及时跟进客户、沟通客户，保留完成沟通记录；根据访客的行为自动分类，同步高意向客户进入CRM系统，进行有效跟进与管理',
          src:require('../assets/img/card-img4.png'),
        }
      ]
    },
    modular3:{
      title:'使用场景',
      p:'轻松打造个人IP，一键分享至好友、群、朋友圈，裂变式传播；智能跟踪客户轨迹，分析客户购买意向；企业打造动态移动官网，多维度的品牌宣传，立体化的企业形象展示。',
      img:{
        imgsrc:require('../assets/img/card-img5.png'),
      }
    }
  },
  Show:{
    modular1:{
      title:'多种场景轻松满足',
      img:{
        imgsrc:require('../assets/img/show-img1.png'),
      },
    },
    modular2:{
      title:'全网营销 . 商机在手',
      p:'',
      class:'card',
      img:null,
      ullist:[
        {
          title:'在线编辑 • 轻松上手',
          p:'通过易企秀在线编辑器，对选定的精美模板进行替换或修改，鼠标轻轻拖拽即可进行图文替换编辑，轻轻松松在模板中添加文字、图片、音乐等元素，创作一个H5作品操作就是如此简单，创作成功后即可分享',
          src:require('../assets/img/show-img2.png'),
        },
        {
          title:'海量资源 • 快速更新',
          p:'6大类产品，20多万的海量模板支持全行业应用，优质素材快速更新，满足用户在不同场景、不同用途下的使用需求',
          src:require('../assets/img/show-img3.png'),
        },
        {
          title:'客户管理 • 跟进开发',
          p:'通过场景秀收集的用户数据，系统自动同步到慧营销CRM，快速收集管理高意向客户，销售自主对接客户，快速响应意向客户需求，提升客户的服务满意度',
          src:require('../assets/img/show-img4.png'),
        }
      ]
    },
    modular3:{
      title:'使用场景',
      p:'能满足不同用户的多种场景',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/show-img5.png'),
      }
    }
  },
  Poster:{
    modular1:{
      title:'多种场景轻松满足',
      img:{
        imgsrc:require('../assets/img/poster-img1.png'),
      },
    },
    modular2:{
      title:'海报传播 • 裂变增长',
      p:'一款公众号涨粉工具',
      pclass:'pclass',
      img:{
        imgsrc:require('../assets/img/poster-img2.png'),
      },
      bp:'以奖品为诱因激励粉丝推荐公众号给好友关注，以此实现公众号涨粉引流。好友被邀请关注后，好友同步收到奖品激励也会参与活动，这样就开启了下一波推荐，从而达到不断传播形成裂变。'
    },
    modular3:{
      title:'',
      p:'转发海报粉丝暴涨',
      pclass:'pclass',
      class:'card poster',
      ullist:[
        {
          p:'商家设置好奖品与粉丝需要邀请的人数，粉丝在公众号内获得专属海报，粉丝转发海报给好友，邀请好友关注。好友关注后也可以引导参与，然后进行循环达到粉丝暴涨。',
          src:require('../assets/img/poster-img3.png')
        }
      ]
    },
    modular4:{
      title:'使用场景',
      p:'当商家拥有一定存量的粉丝启动量，即可开启活动。如教育行业可以利用自身产品特性以课程作为活动奖品，吸引用户参与，可以实现老用户带新用户，来获取课程奖励，新用户被课程所吸引也会参与。从而达到商家品牌曝光，高意向客户获取等目的。',
      img:{
        imgsrc:require('../assets/img/poster-img4.png'),
      },
    },
  },
  Hot:{
    modular1:{
      title:'热点文章植入轻松裂变广告',
      img:{
        imgsrc:require('../assets/img/hot-img1.png'),
      },
    },
    modular2:{
      title:'热点文章 • 快速分享',
      p:'热点推广是基于微信文章的一种改造页，用户可植入带有品牌特性的广告图片',
      class:'card',
      ullist:[
        {
          title:'热点文章 • 快速转化',
          p:'通过文章的自带热度，用户打开即可看到广告形成转换。系统每日会推荐不同分类的热度文章，并展示该文章的目标群体，简单的操作流程，就能形成更加有效的曝光',
          src:require('../assets/img/hot-img2.png')
        },
        {
          title:'方便客户 • 传播品牌',
          p:'基于微信文章改造，易于终端客户方便、快捷的了解品牌，熟悉企业相关的服务产品；文章本身自带传播属性，通过在好友、朋友圈之间传播，能将广告品牌传播的更加深远',
          src:require('../assets/img/hot-img3.png')
        },
      ]
    }, 
    modular3:{
      title:'使用场景',
      p:'销售朋友圈素材可从此应用获取，通过文字植入广告的特性。能够让品牌广告更容易形成传播，此应用适用于微信内存在大量客户资源的销售行业。',
      img:{
        imgsrc:require('../assets/img/hot-img4.png'),
      },
    },
  },
  LetterE:{
    modular1:{
      title:'多角度品牌传播',
      p:'',
      img:{
        imgsrc:require('../assets/img/letterE-img1.png'),
      },
    },
    modular2:{
      title:'品牌宣传 • 更多花样',
      p:'融e信是基于运营商的一种彩信形式，用户可制作e信模板便捷传播。通过e信多媒体融合展示的特性，用户打开即可多维度的看到品牌展示，基于运营商通道服务，到达率高、内容形式多样化，帮助用户高效的熟悉企业相关的服务产品',
      img:{
        imgsrc:require('../assets/img/letterE-img2.png'),
      },
    },
    modular3:{
      title:'使用场景',
      p:'可利用融e信展示性好的特点，多个角度助力品牌曝光、产品推广、服务通知、活动告知等各样企业商用场景。',
      img:{
        imgsrc:require('../assets/img/letterE-img3.png'),
      },
    },
  },
  wxMarket:{
    modular1:{
      title:'沟通从未如此愉悦',
      p:'',
      img:{
        imgsrc:require('../assets/img/wxMarket-img1.png'),
      },
    },
    modular2:{
      title:'沟通高效 • 更多可能',
      p:'',
      class:'card',
      ullist:[
        {
          title:'随时沟通 • 便捷高效',
          p:'• 手机APP和电脑端数据同步，历史沟通数据完整呈现<br />• 用户可以通过文字、图片等多种方式与客户发起沟通信息交流无障碍；常用话术可以快捷的发送，无需编辑文字，选中即刻发送',
          src:require('../assets/img/wxMarket-img2.png')
        },
        {
          title:'客户关怀 • 智能推送',
          p:'• 随时关注客户的朋友圈，用户可以随时发送朋友圈信息<br /> • 制定客户关怀计划，系统智能提醒、只能发送客户关怀',
          src:require('../assets/img/wxMarket-img3.png')
        },{
          title:'行业话术 • 提效降本',
          p:'• 根据行业不同，制定不同的行业话术<br />• 便于用户根据不同客户的属性，快捷、高效的与用户进行沟通<br />• 提升工作效率，降低人力成本',
          src:require('../assets/img/wxMarket-img4.png')
        },
      ]
    },
    modular3:{
      title:'使用场景',
      p:'随着电话营销的方式越来越多的收到政策的管控，企业的销售模式会更多的借助微信来与客户沟通，降低电销频率，提升沟通效率、降低电销成本；企业通信电话营销联系到客户，客户表示意向后，销售成功添加客户微信，系统保护销售客户的归属权，销售通过微信与客户沟通，客户信息安全、沟通信息完整保留',
      img:{
        imgsrc:require('../assets/img/wxMarket-img5.png'),
      },
    },
  },
  Robot:{
    modular1:{
      title:'人机对比',
      p:'',
      left:'传统',
      right:'小蜂助手',
      ullist:[
        {
          p1:'拓客效率低，挂断率高，承担率低，电话时长，无效电话多，每天100-500通',
          p2:'高效拓客，海量呼出，4-5倍于人工效率，外呼话术定制，贴近真人对话，外呼时间自主设定',
          title:'工作效率',
          src:require('../assets/img/robot-icon1.png'),
        },
        {
          p1:'多种因素影响，情绪波动大',
          p2:'全年无休，12小时全天候工作，情绪稳定，状态饱满，永不疲劳',
          title:'工作状态',
          src:require('../assets/img/robot-icon2.png'),
        },
        {
          p1:'新人培训周期长，短期内专业程度低',
          p2:'销售精英话术，智能优化话术，强大的CRM系统，销售的漏斗分层管理',
          title:'专业程度',
          src:require('../assets/img/robot-icon3.png'),
        },
        {
          p1:'成本高，招人难、管理难，人员流动大，培训周期长',
          p2:'无需考虑人员变动，号码批量导入，机器自动外呼，主动营销，自动转化，远远低于人工成本',
          title:'运营成本',
          src:require('../assets/img/robot-icon4.png'),
        }
      ]
    },
    modular2:{
      title:'小蜂助手',     
      img:null,
      class:'robotModular2',
      ullist:[
        {
          title:'AI自主学习',
        },{
          title:'私人助理',
        },{
          title:'自动拨打',
        },{
          title:'识别精准',
        },{
          title:'多轮会话',
        },{
          title:'真人语音',
        },{
          title:'灵活打断',
        },{
          title:'自动分类',
        },{
          title:'自动记录',
        }
      ],
      bp:''
    },
    modular3:{
      title:'功能与特点',
      class:'robotModular3',
      ullist:[
        {p:'<em>快速反映:</em>采用ASR、NLP、DM等能力，并自主研发专利技术，响应时间快达400-700毫秒，完全媲美真人体验(真人通话的响应时间90%在1.5-2秒之间) '},
        {p:'<em>准确识辨:</em>业界准确的语音意图识别和对话管理，准确挖掘用户需求，定义用户画像，筛选意向用户'},
        {p:'<em>真人语音:</em>可自主选择不同会话语音，真人或小蜂助手语音多重引擎，私人定制销售话术'},
        {p:'<em>灵活打断:</em>在小蜂助手说话过程中，用户可以随时打断通话，灵话插话;开放对话管理引擎，客户可以自主配置，修改小蜂助手话术和知识库'},
        {p:'<em>多轮会话:</em>多轮会话技术，对海量通话数据进行信息发掘和统计，了解客户，洞察市场，优化产品、服务、营销方式'}
      ]
    },
    modular4:{
      title:'多行业场景适用',
      class:'robotModular4',
      ullist:[
        {title:'电商',p:'营销/推广/广告<br />客户咨询'},
        {title:'教育',p:'邀约/通知/营销<br />客户咨询'},
        {title:'房地产',p:'营销/邀约/调查<br />装修/中介'},
        {title:'汽车',p:'营销/回访<br />客户咨询/售后服务'},
        {title:'政府事业',p:'民政/社保/医院<br />热线/调查'},
        {title:'商业服务',p:'财税/推广/广告<br />招商/客服咨询'}
      ]
    },
    modular5:{
      title:'全新计价模式，全国低价',
      p:'',
      img:{
        imgsrc:require('../assets/img/robot-img4.png'),
      },
    },
  },
  Customer:{
     modular1:{
      title:'沟通从未如此愉悦',
      img:{
        imgsrc:require('../assets/img/customer-img1.png'),
      },
    },
    modular2:{
      title:'高效管理 . 智能会话',
      pclass:'pclass',
      p:'多公众号• 精细化管理',
      img:{
        imgsrc:require('../assets/img/customer-img2.png'),
      },
      bp:'• 不同公众号的素材、客服话术统一管理<br />• 用户扫描绑定微信公众号，多公众号同时管理，同步公众号粉丝信息<br />• 客服依据标签对粉丝进行分类管理，便于客服精准定位、筛选粉丝群，进行二次营销或售后服务'
    },
    modular3:{
      title:'智能会话 • 高效沟通',
      img:{
        imgsrc:require('../assets/img/customer-img3.png'),
      },
      bp:'• 微信用户关注公众号、主动咨询客服、触发关键词系统自动发起回复，及时响应，提升客服满意度<br />• 企业定制业务知识库，快捷回复，降低客服人员的学习成本，提升沟通效率'
    },
    modular4:{
      title:'使用场景',
      p:'在1个工作台上同时处理多渠道客服信消息，避免客服人员后台来回切换，有效提高消息响应速率',
      img:{
        imgsrc:require('../assets/img/customer-img4.png'),
      },
    },
  },
  sale:{
    modular1:{
      title:'产品中心',
      p:'服务创造价值 存在造就未来',
      img:{
        imgsrc:require('../assets/img/sale1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:''
    },
    modular2:{
      title:'电话销售专用卡',
      p:'电话销售专用，适合销<br />售使用的电销卡与套餐，归<br>属地定制全国地区随便打',
      img:{
        imgsrc:require('../assets/img/sale1.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:''
    },
    modular3:{
      title:'定制归属地电销卡',
      p:'电话销售专用卡全国归属地定制',
      img:{
        imgsrc: require('../assets/img/sale2.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
      bp:''
    },
    modular4:{
      title:'我们的优势',
      img:{
        imgsrc:require('../assets/img/sale3.png'),
      }
    },
    modular5:{
      title:'企业通信畅达无忧',
      p:'为企业提供基于固话、手机的软硬一体化的通信解决方案<br/>支持移动、联通、电信三大运营商<br/>支持4G全网通，双卡智能切换<br/>提供开放的API接口，快捷方便接入第三方软件',
      img:{
        imgsrc:require('../assets/img/home-img8.png'),
        imgtitle:'',
        imgalt:'',
        class:''
      },
    },
    modular6:{
      title:'客户案例',
      p: '超过100000家企业使用我们产品和服务',
      img:{
        imgsrc:require('../assets/img/home-img10.png'),
      }
    },
  },
}

export default {
  websiteText
}
